import React from 'react';

const Vue_v_else = () => {
  return (
    <div>
      <h1>Vue_v_else Component</h1>
      <p>This is the Vue_v_else tutorial page.</p>
    </div>
  );
}

export default Vue_v_else;
